<template>
  <generic-list :apiUrls="apiUrls" :formCols="formCols" :updateCols="updateCols" :tableCols="tableCols"></generic-list>
</template>

<script>
import genericList from '@/views/commonPage/genericList.vue'
import URL from '@/views/business/util/url'
import Qs from 'qs'

let pushConfig = { "1": "需第三方推送", "2": "不需要第三方推送" };
let msgPlatform = { "all": "ALL", "Android": "Android", "IOS": "IOS", "HarmonyOS": "HarmonyOS" };
let pushMode = { "1": "即时", "2": "定时" };
let type = { "1": "重要公告", "2": "系统维护公告", "3": "任务更新" };
let pushStatus = { "1": "待发布", "2": "已发布", "3": "发布失败", "4": "已撤回", "5": "暂停发布" };
let isDelete = { "1": "启用", "2": "禁用" };
let pop = { "1": "否", "2": "是" };
let noticeDisplay = { "1": "否", "2": "是" };
let mobileBrands = { "1": "华为", "2": "小米", "3": "OPPO", "4": "vivo", "5": "一加", "6": "realme", "7": "Hi nova", "8": "努比亚", "9": "iQOO", "10": "苹果", "11": "Moto", "12": "三星", "13": "魅族", "14": "黑鲨", "15": "红米", "16": "联想", "17": "荣耀", "18": "中兴" };
let levelCard = {};

export default {
  name: "noticePushMsg",
  components: {
    genericList
  },
  created() {
    this.initLevel()
  },
  methods: {
    initLevel() {
      this.$axios.post(URL.common.configKey, Qs.stringify({
        // 如果需要传递参数，可以在这里传递
        paramKey: "miLevelDict"
      })).then(res => {
        if (res.code === 0) {
          if (res.result && res.result.paramValue) {
            //  console.log(res.result.paramValue);
            // 请求成功，将响应数据赋值给 levelCard
            this.levelCard = JSON.parse(res.result.paramValue);
          } else {
            console.error('请求失败');
          }
        } else {
          console.error('请求失败');
        }
      })
    }
  },
  watch: {
    levelCard: {
      deep: true,
      handler(newVal) {
        this.updateCols.find(c => c.field === 'grade').optionList = newVal;
        this.formCols.find(c => c.field === 'grade').optionList = newVal;
      }
    }
  },
  data() {
    return {
      levelCard: {},
      apiUrls: {
        query: URL.noticePushMsg.query,
        addOrUpdate: URL.noticePushMsg.addOrUpdate,
        deleteBatchIds: URL.noticePushMsg.deleteBatchIds,
        back: URL.noticePushMsg.back
      },
      formCols: [
        { title: '公告类型', field: 'type', type: 2, optionList: type },
        { title: '公告名称', field: 'msgTitle' },
        { title: '推送平台', field: 'msgPlatform', multiple: true, type: 2, optionList: msgPlatform },
        { title: '推送机型', field: 'mobileBrands', multiple: true, type: 2, optionList: mobileBrands },
        { title: '指定等级', field: 'grade', multiple: true, type: 2, optionList: levelCard },
        { title: '指定会员', field: 'users' },
        { title: '最后更新时间', field: 'time1', type: 6, format: 'yyyy-MM-dd HH:mm:ss', startEndParam: ['updateDateBegin', 'updateDateEnd'] },
        { title: '推送时间', field: 'time2', type: 6, format: 'yyyy-MM-dd HH:mm:ss', startEndParam: ['pushTimeBegin', 'pushTimeEnd'] },
        { title: '状态', field: 'pushStatus', type: 2, optionList: pushStatus },
        { click: window.$t('business.bt.search') },
        { click: window.$t('business.bt.add') }
      ],
      updateCols: [
        { title: 'id', field: 'id', hidden: true },
        { title: 'jobId', field: 'jobId', hidden: true },
        { title: 'pushStatus', field: 'pushStatus', hidden: true },
        { title: '公告类型', field: 'type', required: true, type: 2, isNumber: true, optionList: type },
        { title: '公告标题', field: 'msgTitle', maxlength: 50, required: true },
        { title: '消息内容', field: 'msgContent', type: 6, uploadUrl: URL.detailTask.uploadUrl, required: true },
        { title: '外部页面URL', field: 'msgUrl' },
        { title: '指定等级', field: 'grade', multiple: true, type: 2, optionList: levelCard, data: [] },
        { title: '指定会员', field: 'users' },
        { title: '推送平台', field: 'msgPlatform', multiple: true, type: 2, optionList: msgPlatform, data: [], required: true },
        { title: '推送机型', field: 'mobileBrands', multiple: true, type: 2, optionList: mobileBrands, data: [] },
        { title: '推送方式', field: 'pushMode', type: 2, optionList: pushMode, isNumber: true, required: true },
        {
          title: '推送时间', field: 'pushTime', format: "yyyy-MM-dd HH:mm:ss", type: 5,
          hidden: (updateModel, col) => {
            return updateModel.pushMode == "1" || updateModel.pushMode === undefined
          }, required: (updateModel, col) => {
            return updateModel.pushMode == "2"
          }
        },
        { title: '系统是否弹窗', field: 'pop', type: 2, optionList: pop, isNumber: true, required: true },
        { title: '通知栏是否显示', field: 'noticeDisplay', type: 2, optionList: noticeDisplay, isNumber: true, required: true }
      ],
      tableCols: [
        {
          title: '公告类型', field: 'type',
          render: (data, full) => {
            return type[data];
          }
        },
        { title: '公告标题', field: 'msgTitle', h5Click: 'detail' },
        {
          title: '状态', field: 'pushStatus',
          render: (data, full) => {
            return pushStatus[data];
          }
        },
        {
          title: '推送平台', field: 'msgPlatform', render: (data, full) => {
            const platform = Array.isArray(data) ? data : (data || '').split(',');
            return platform.map(b => msgPlatform[b]).join(',');
          }
        },
        {
          title: '推送机型', field: 'mobileBrands', render: (data, full) => {
            const brands = Array.isArray(data) ? data : (data || '').split(',');
            return brands.map(b => mobileBrands[b]).join(',');
          }
        },
        {
          title: '指定等级', field: 'grade', render: (data, full) => {
            return Array.isArray(data) ? [...data].sort((a, b) => a - b).join(',') : data;
          }
        },
        { title: '指定会员', field: 'users' },
        {
          title: '是否弹窗', field: 'pop', render: (data, full) => {
            return pop[data];
          }
        },
        {
          title: '通知栏显隐', field: 'noticeDisplay', render: (data, full) => {
            return noticeDisplay[data];
          }
        },
        { title: '发送量', field: 'numSend' },
        { title: '触达量', field: 'numReach' },
        { title: '创建人', field: 'createUser' },
        { title: '修改人', field: 'updateUser' },
        { title: '创建时间', field: 'createDate' },
        { title: '修改时间', field: 'updateDate' },
        { title: '推送时间', field: 'pushTime' },
        { title: '撤回时间', field: 'returnDate' },

        {
          title: window.$t("business.bt.operation"), minWidth: "180", btnClick: [
            {
              name: window.$t("business.bt.edit"), click: "update", type: "primary", size: "mini", icon: "el-icon-edit", disabled: (data, full) => {
                let result = false;
                if (full.pushStatus !== 1) {
                  result = true;
                }
                return result;
              }
            },
            {
              name: window.$t("business.bt.delete"), click: "delete", type: "primary", size: "mini", icon: "el-icon-delete", disabled: (data, full) => {
                let result = false;
                if (full.pushStatus !== 1) {
                  result = true;
                }
                return result;
              }
            },
            {
              name: window.$t("business.bt.back"), click: "back", type: "primary", size: "mini", icon: "el-icon-edit", disabled: (data, full) => {
                let result = false;
                //推送成功才能撤回
                if (full.pushStatus !== 2) {
                  result = true;
                }
                return result;
              }
            },
          ]
        },
      ]
    };
  }
}
</script>